import { render, staticRenderFns } from "./kdManagerSubmit.vue?vue&type=template&id=3db52d13&scoped=true"
import script from "./kdManagerSubmit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdManagerSubmit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db52d13",
  null
  
)

export default component.exports